import { routeNames } from 'shared_DEPRECATED/utils/config';

export const ACCOUNTABILITY_PARTNER_SPRINT_ROUTE_PATH = `${routeNames.CONNECTIONS}/:email/sprints/:sprintId`;
